"use client";
import {
  useHovercardHeading
} from "../__chunks/BTK3EXKD.js";
import "../__chunks/4FY2MBIB.js";
import "../__chunks/6FZVKQWP.js";
import "../__chunks/OYB5INBF.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-heading.tsx
var TagName = "h1";
var useMenuHeading = createHook(
  function useMenuHeading2(props) {
    props = useHovercardHeading(props);
    return props;
  }
);
var MenuHeading = forwardRef(function MenuHeading2(props) {
  const htmlProps = useMenuHeading(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuHeading,
  useMenuHeading
};
